'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.NachwuchsfoerderungSchema = {
  title: 'Nachwuchsfoerderung',
  type: 'object',
  properties: Object.assign({}, baseProperties)
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/nachwuchsfoerderung.js
// module id = wvwP
// module chunks = 0